import { filterNullOrUndefined } from '../transformations/filterNullOrUndefined.js';
import { getNonFunctionProperties } from '../transformations/getNonFunctionProperties.js';
import maskPII from '../transformations/maskPII.js';
import { Destination } from './Destination.js';
export default class CventAnalyticsDestination extends Destination {
    constructor() {
        super(...arguments);
        this.name = 'CventAnalytics';
    }
    async baseTransform(action, data) {
        const restOfAction = getNonFunctionProperties(action, ['data', 'id', 'ts', 'destinations']);
        return {
            type: action.id,
            ts: action.ts,
            ...maskPII(filterNullOrUndefined({ ...restOfAction, ...data }))
        };
    }
}
//# sourceMappingURL=CventAnalytics.js.map